export const environment = {
  production: false,
  eliquaRestURL: 'https://shopflix.uat.qivos.net/ci-shopflix-UAT/rest/v1/',
  clientName: 'shopflix',
};
